import { extendTheme } from "@chakra-ui/react"
import { mode } from "@chakra-ui/theme-tools";

const theme = {
  styles: {
    global: props => ({
      body: {
        bg: mode("gray.50", "gray.800")(props),
      }
    })
  },
  colors: {
    primary: "rebeccapurple",
  },
  components: {
    Container: {
      sizes: {
        md: {
          maxWidth: "50rem",
        },
      }
    }
  }
}

export default extendTheme(theme)
